import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="highlight-button"
// Handles clicking on highlight buttons (yellow, pink, orange, eraser)
export default class extends Controller {
  static values = {
    color: String
  }

  click(event) {
    event.preventDefault()

    const $ = window.$
    if (!$) {
      console.warn('[highlight-button] jQuery not available')
      return
    }

    // Check if clickHighlightButton function is available from highlight.js
    if (typeof window.clickHighlightButton === 'function') {
      // Call the original function with the correct context (this element)
      window.clickHighlightButton.call(this.element)
    } else {
      // Fallback: implement basic highlight button functionality
      // This matches the behavior from highlight.js clickHighlightButton function
      const $element = $(this.element)

      if ($element.hasClass("interface-highlight-button-border-yash")) {
        // If already selected, deselect it
        $element.removeClass("interface-highlight-button-border-yash")
        if (window.highlighter) {
          window.highlighter.eraserClicked = false
          window.highlighter.highlighterClicked = false
        }
      } else {
        // Select this button and deselect others
        $element.addClass("interface-highlight-button-border-yash")
        $(".interface-highlight-button-yash")
          .filter(function() {
            return this != $element[0]
          })
          .removeClass("interface-highlight-button-border-yash")

        // Enable highlighter or eraser
        if ($element.hasClass("interface-eraser-button-yash")) {
          if (window.highlighter) {
            window.highlighter.eraserClicked = true
            window.highlighter.highlighterClicked = false
          }
        } else {
          if (window.highlighter) {
            window.highlighter.eraserClicked = false
            window.highlighter.highlighterClicked = true
          }
        }
      }

      // Set the color
      if (window.highlighter) {
        window.highlighter.color = null
        const color = this.colorValue || $element.data("color")
        if (window.highlighter.highlighterClicked && color) {
          window.highlighter.color = color
        }
      }

      // Detach and reattach highlight events if needed
      if (typeof window.detachHighlightEvents === 'function') {
        window.detachHighlightEvents()
      }
      if (window.highlighter && (window.highlighter.highlighterClicked || window.highlighter.eraserClicked)) {
        if (typeof window.attachHighlightEvents === 'function') {
          window.attachHighlightEvents()
        }
      }
    }
  }
}

